import { format } from 'date-fns/fp';
import { subDays } from 'date-fns';

export const formatDate = format('EEE, MMM d');

export const formatDateRange = ({ maxRangeDays, minRangeDays }) => {
  const today = new Date();
  const formattedMinDate = formatDate(subDays(today, Math.abs(minRangeDays)));
  const formattedMaxDate = formatDate(subDays(today, Math.abs(maxRangeDays)));
  return `${formattedMinDate} - ${formattedMaxDate}`;
};
